import { RouteRecordRaw } from "vue-router"

export const purchaseRoutes: RouteRecordRaw[] = [
	{
		path: "/purchase",
		component: () => import("@/views/purchase/index.vue"),
		redirect: "/purchase/account",
		children: [
			{
				path: "/purchase/account",
				component: () => import("@/views/purchase/account.vue")
			},
			{
				path: "/purchase/noAccount",
				component: () => import("@/views/purchase/noAccount.vue")
			}
		]
	},
	{
		path: "/purchaseRecord",
		component: () => import("@/views/purchase/purchaseRecord.vue")
	},
	{
		path: "/trialAccount",
		component: () => import("@/views/tryOut/index.vue")
	},
	{
		path: "/apply",
		component: () => import("@/views/tryOut/apply.vue")
	},
	{
		path: "/applySuccess",
		component: () => import("@/views/purchase/buySuccess.vue")
	},
	{
		path: "/purchaseProduct",
		component: () => import("@/views/purchase/purchase.vue")
	}
]
